const last = require('lodash/last');
const get = require('lodash/get');
const moment = require('moment');
const { unitTypes } = require('../config/medication');
const positions = require('../config/positions');
const bodyTypes = require('../config/bodyTypes');
const physicalAssessmentLocations = require('../config/physicalAssessmentLocations');
const iv = require('../config/iv');

function groupLabel(group) {
  return last(group.name.split('::'));
}

function userLabel(user) {
  if (user) {
    return (
      `${user.given_name || ''} ${user.family_name || ''}`.trim() || user.email
    );
  }
  return 'Unknown';
}

const roleLabels = {
  ADMIN: 'Admin',
  SUPER_ADMIN: 'Super Administrator',
  USER: 'Instructor',
  STUDENT: 'Student',
};

function userRoleLabel(user, orgId = null) {
  const role =
    get(user, `app_metadata.orgSpecificRoles.${orgId}`) ||
    user.app_metadata.role;
  return roleLabels[role] || 'UNKNOWN';
}

function dateLabel(date) {
  return date ? moment(date).format('YYYY-MM-DD') : '';
}

function unitLabel(unitEnum) {
  // For legacy cases without unit types
  if (unitEnum === 'UNKNOWN') {
    return ' (no unit)';
  }
  const unit = unitTypes.find((u) => u.key === unitEnum);
  if (!unit) {
    return unitEnum;
  }
  return unit.label.en;
}

function timeLabel(timeInSeconds) {
  return `${Math.floor(timeInSeconds / 60)}:${(
    timeInSeconds % 60
  ).toLocaleString('en-US', {
    minimumIntegerDigits: 2,
  })}`;
}

function positionLabel(positionEnum, language = 'en') {
  const position = positions.find(p => p.key === positionEnum);
  return position ? position.label[language] : 'Unknown';
}

function bodyTypeLabel(typeEnum, language = 'en') {
  const bodyType = bodyTypes.find(b => b.key === typeEnum);
  return bodyType ? bodyType.label[language] : 'Unknown';
}

function physicalAssessmentLocationLabel(locationEnum, language = 'en') {
  const location = physicalAssessmentLocations.find(
    location => location.key === locationEnum
  );
  return location ? location.label[language] : 'Unknown';
}

function ivSiteLabel(siteEnum, language = 'en') {
  const ivSite = iv.sites.find(ivSite => ivSite.key === siteEnum);
  return ivSite ? ivSite.label[language] : 'Unknown';
}

function displayTypeLabel(displayType) {
  switch (displayType) {
    case 'UNKNOWN':
      return 'Unknown';
    case 'FLAT':
      return 'Web Browser';
    default:
      return displayType;
  }
}

module.exports = {
  groupLabel,
  userLabel,
  userRoleLabel,
  dateLabel,
  unitLabel,
  timeLabel,
  positionLabel,
  bodyTypeLabel,
  physicalAssessmentLocationLabel,
  ivSiteLabel,
  displayTypeLabel,
};
